import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../lib/auth-context';

// Telas Administrativas
import { AdminLoginPage } from '../pages/admin/AdminLoginPage';
import {
  AdminDashboardPage,
  AdminOverviewPage,
  AdminSettingsPage,
  AdminMessagesPage,
  AdminUsersPage,
  AdminErrorsPage,
  AdminCollectionRouteWrapper,
  ServerSettingsPage,
} from '../pages/admin/sections/AdminDashboardPage';

export function RoutesAdmin() {
  return (
    <Route path="/admin">
      {/* Login Administrativo */}
      <Route path="login" element={<AdminLoginPage />} />

      {/* Painel Protegido */}
      <Route
        element={
          <ProtectedRoute>
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      >
        {/* Visão Geral (Dashboard BI) */}
        <Route index element={<AdminOverviewPage />} />

        {/* Módulos do Sistema */}
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="server" element={<ServerSettingsPage />} />
        <Route path="messages" element={<AdminMessagesPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="errors" element={<AdminErrorsPage />} />

        {/* CRUD Dinâmico das Coleções (/admin/services, etc.) */}
        <Route path=":collection" element={<AdminCollectionRouteWrapper />} />

        {/* Redirecionamentos de Legado */}
        <Route path="servicos" element={<Navigate to="/admin/services" replace />} />
        <Route path="projetos" element={<Navigate to="/admin/projects" replace />} />
        <Route path="mensagens" element={<Navigate to="/admin/messages" replace />} />
        <Route path="usuarios" element={<Navigate to="/admin/users" replace />} />
      </Route>
    </Route>
  );
}